import defaults from 'lodash/defaults';

const DEFAULT_THRESHOLDS = { mobile: 500 };
let thresholds = DEFAULT_THRESHOLDS;

export const isMobileView = () =>
  window.screen.width < thresholds.mobile ||
  !window.matchMedia(`(min-width:${thresholds.mobile}px)`).matches;

export const getResponsiveValue = settings => {
  if (!settings) return null;
  return isMobileView() ? settings.mobile : settings.desktop;
};

export const setMediaQueryThresholds = settings => {
  thresholds = defaults({ ...settings }, DEFAULT_THRESHOLDS);
};

// Is the website scaled down (or up) to match the viewport?
// Some websites use a hack to avoid responsive design: they design a website for
// fixed width (e.g. 720px) and set it as the viewport width (using a meta tag),
// so that mobile browsers of different sizes will scale the content to match their
// own width. E.g. a device with 360px width will use 50% scale to fit the 720px.
// 100% means there is no scaling.
const initialViewportScale = window.visualViewport?.scale || 1;

// Returns the scaling factor needed to reverse the effects of viewport scale.
// E.g. if the page content is scaled down to 25%, we'll have to scale the widget
// up by 400% to make it roughly as intended.
export const getSuggestedScale = () => 1 / initialViewportScale;
